module.exports = __webpack_public_path__ + "img/map-2.e5ce8ffd.gif";